import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import back from "../assets/images/back_arrow.png";
import { useNavigate } from "react-router-dom";
import plus from "../assets/images/plus.png";
import InfoIcon from "@mui/icons-material/Info"; // Import Info icon
import "../App.css";
import camera from "../assets/images/camera.png";
import Webcam from "react-webcam";
import cameraSwitch from "../assets/images/cameraSwitch.png";
import select from "../assets/images/select.jpg";
import cross from "../assets/images/cross.png";
import $ from "jquery";
import Axios from "axios";
import documents from "../assets/images/documents.png";
import deleteicon from "../assets/images/delete-icon.jpg";
import folder from "../assets/images/folder.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Collapsible from "react-collapsible";
import Spinner from "../components/Spinner";
import { message } from "antd";
import "../css/Header.css";
export default () => {
  const navigate = useNavigate();
  const [addRecordButtonHide, setAddRecordButtonHide] = useState(false);
  const [openCameraButton, setOpenCameraButton] = useState(false);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState("");
  const [base64ImageToFile, setBase64ImageToFile] = useState("");
  const [file_type, setFile_type] = useState("");
  const [isCapturePhotoHide, setIsCapturePhotoHide] = useState(false);
  const [isOpenDocumentCategory, setIsOpenDocumentCategory] = useState(false);
  const [reportsCategory, setReportsCategory] = useState("");
  const [document_name, setDocument_name] = useState("");
  const [isButtonHide, setIsButtonHide] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [isEmptyDocumentName, setIsEmptyDocumentName] = useState(false);
  const [noRecords, setNoRecords] = useState(false);
  const [isDeleteDoc, setIsDeleteDoc] = useState(false);
  const [uploadedDocId, setUploadedDocId] = useState("");
  const [refreshUploadedDoc, setRefreshUploadedDoc] = useState(false);
  const [uploadedFolder, setUploadedFolder] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoFile, setIsNoFile] = useState(false);
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  const [isInputSectionOpen, setIsInputSectionOpen] = useState(false);
  const [backButtonHide, setBackButtonHide] = useState(false);
  const [doctorsName, setDoctorsName] = useState("");
  const [visitingPurpose, setVisitingPurpose] = useState("");
  const [seesionId, setSeesionId] = useState(Number);
  const [buttonHide, setButtonHide] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); // State for modal
  let pid;

  const location = useLocation();

  const FACING_MODE_USER = "user";
  const FACING_MODE_ENVIRONMENT = "environment";

  const videoConstraints = {
    facingMode: FACING_MODE_ENVIRONMENT,
  };

  const [facingMode, setFacingMode] = useState(FACING_MODE_ENVIRONMENT);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleClick = useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_ENVIRONMENT
        ? FACING_MODE_USER
        : FACING_MODE_ENVIRONMENT
    );
  }, []);

  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/");
  };
  // const handleClickOpen = () => {
  //     setOpen(true);
  // };
  const webcamRef = React.useRef(null);

  const startCam = () => {
    console.log("camera is opening");
    setCameraOpen(true);
    setIsCapturePhotoHide(false);
    setRefreshUploadedDoc(false);
  };

  const addRecordsHandler = () => {
    setAddRecordButtonHide(true);
    setOpenCameraButton(true);
  };
  const backToRecordsHandler = () => {
    setIsInputSectionOpen(false);
    setBackButtonHide(true);
    setAddRecordButtonHide(false);
    setOpenCameraButton(false);
    setCameraOpen(false);
    setCapturedImage("");
  };
  const selectedPhotoHandler = () => {
    setIsOpenDocumentCategory(true);
  };

  const reportsCategoryChangeHandler = (e) => {
    setReportsCategory(e.target.value);
    if (e.target.value == "Prescription") {
      setDocument_name("Prescription");
    }
  };

  const capturePhoto = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    // console.log("captured image ", imageSrc);
    setCapturedImage(imageSrc);
    setIsCapturePhotoHide(true);

    console.log("captured photo  ", imageSrc);
    const url = imageSrc;
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "Filename.jpeg", { type: "image/jpeg" });
        console.log(file);
        setBase64ImageToFile(file);
        setFile_type("image/jpeg");
      });
  }, [webcamRef]);
  const documentNameChangeHandler = (e) => {
    setDocument_name(e.target.value);
  };

  useEffect(() => {
    const getUploadFolder = async () => {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
      };

      setRefreshUploadedDoc(true);

      pid = localStorage.getItem("patientid");
      console.log(pid);
      setSeesionId(pid);

      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/get_uploaded_folder?patients_id_fk=${pid}&MDT=PM&user_role=rp`,
          { headers }
        );

        console.log("Uploaded folder success response", response.data);
        setLoading(false);

        if (response.data.status == "1") {
          if (response.data.data.length > 0) {
            setUploadedFolder(response.data.data);
          } else {
            setNoRecords(true);
          }
        } else if (response.data.status === "401") {
          logoutHandler();
        } else if (response.data.status === "0") {
          message.error("An error occurred. Please try again.");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error("Unauthorized access. Logging out.");
          message.error(error.response.data?.message || "Unauthorized");
          logoutHandler();
        } else {
          console.error("Error:", error.message);
          message.error("An error occurred. Please try again.");
        }
      }
    };
    getUploadFolder();
  }, []);

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");
  };

  const handleDeleteClickOpen = (id) => {
    setDeleteOpen(true);
    setUploadedDocId(id);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const uploadRecords = (e) => {
    console.log(pid);
    if (document_name != "") {
      setIsButtonHide(true);
      e.preventDefault();
      let formdata = $(e.target);
      formdata = new FormData();
      formdata.append("file", base64ImageToFile);
      formdata.append('MDT', 'PM');
      formdata.append('user_role', 'rp');
      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/FileUpload/file_insert_patientapp`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log("savehandler:file upload success response:  ", data);
          // alert("file upload successfully");

          if (data) {
            const filedata = new FormData();
            filedata.append(
              "file",
              `${process.env.REACT_APP_GLOBAL_BASEURL}/${data}`
            );
            filedata.append("patients_id_fk", pid);
            filedata.append("category", reportsCategory);
            filedata.append("document_name", document_name);
            filedata.append("document_type", file_type);
            filedata.append('MDT', 'PM');
            filedata.append('user_role', 'rp');

            $.ajax({
              type: "POST",
              url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/insert`,
              data: filedata,
              processData: false,
              contentType: false,
              success(data) {
                console.log(
                  "upload recordshandler:records upload success response:  ",
                  data
                );
                setIsButtonHide(false);
                setRefreshUploadedDoc(true);

                Axios.get(
                  `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/get_uploaded_documents?patients_id_fk=${pid}&MDT=PM&user_role=rp`
                ).then((response) => {
                  console.log(
                    " uploaded documents success response ",
                    response.data
                  );
                  if (response.data.status == "1") {
                    if (response.data.data.length > 0) {
                      setUploadedDocuments(response.data.data);
                    } else {
                      setNoRecords(true);
                    }
                  }
                  setAddRecordButtonHide(false);
                  setOpenCameraButton(false);
                  setCameraOpen(false);
                  setCapturedImage("");
                  setReportsCategory("");
                  setIsOpenDocumentCategory(false);
                });
              },
              error: function (err) {
                console.log(err.responseText);
                alert(`Error has occurred: ${err.responseText}`);
              },
            });
          }
        },
        error: function (err) {
          console.log(err.responseText);
          alert(`Error has occurred: ${err.responseText}`);
        },
      });
    } else {
      e.preventDefault();
      console.log("documnt is empty");
      setIsEmptyDocumentName(true);
    }
  };

  const uploadFolder = (e) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    setButtonHide(true);
    // console.log(seesionId)
    if (doctorsName != "" && visitingPurpose != "") {
      e.preventDefault();
      let formdata = $(e.target);
      formdata = new FormData();
      formdata.append("patients_id_fk", seesionId);
      formdata.append("doctors_name", doctorsName);
      formdata.append("visiting_purpose", visitingPurpose);
      formdata.append('MDT', 'PM');
      formdata.append('user_role', 'rp');

      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/create_folder`,
        data: formdata,
        processData: false,
        contentType: false,
        headers: headers,
        success(data) {
          console.log("created folder successfully", data);
          setButtonHide(false);
          window.location.reload(false);
        },
        error: function (err) {
          if (err.status == '401') {
            // Token expired, show message and log out
            message.error(err.responseJSON.message);
            logoutHandler();
          } else {
            console.error("Error occurred:", err.responseText);
            alert(`Error has occurred: ${err.responseText}`);
          }
        },
      });
    } else {
      e.preventDefault();
      setButtonHide(false);
      alert(" Doctors name and visiting purpose are mandatory");
    }
  };

  const openNewTabHandler = (file) => {
    const url = `${file}`;
    window.open(
      url,
      "toolbar=yes,scrollbars=yes,resizable=yes,width=400,height=400"
    );
  };

  const addFolderHandler = () => {
    setAddRecordButtonHide(true);
    setIsInputSectionOpen(true);
  };

  const handleChangeDoctorsName = (e) => {
    setDoctorsName(e.target.value);
  };
  const handleChangeVisitingPurpose = (e) => {
    setVisitingPurpose(e.target.value);
  };

  const deleteDocumentsHandler = (e) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    setIsDeleteDoc(true);
    e.preventDefault();
    let formdata = $(e.target);
    formdata = new FormData();
    formdata.append("id", uploadedDocId);
    formdata.append('MDT', 'PM');
    formdata.append('user_role', 'rp');

    $.ajax({
      type: "POST",
      url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/delete_folder`,
      data: formdata,
      processData: false,
      contentType: false,
      headers: headers,
      success(data) {
        console.log("deleted document response", data);
        // alert("Document deleted");
        setIsDeleteDoc(false);
        setDeleteOpen(false);
        setRefreshUploadedDoc(false);
        window.location.reload(false);
      },
      error: function (err) {
        if (err.status == '401') {
          // Token expired, show message and log out
          message.error(err.responseJSON.message);
          logoutHandler();
        } else {
          console.error("Error occurred:", err.responseText);
          alert(`Error has occurred: ${err.responseText}`);
        }
        setIsDeleteDoc(false);
      },
    });
  };

  const openCollapsibleHandler = (id) => {
    setIsOpenCollapse(true);
    setIsLoading(true);
    setUploadedFile([]);

    Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/get_uploaded_file_by_folder_id?folder_id=${id}&MDT=PM&user_role=rp`
    ).then((response) => {
      console.log(" uploaded file success response ", response.data);
      setIsLoading(false);
      if (response.data.length > 0) {
        setIsNoFile(false);

        setUploadedFile(response.data);
      } else {
        setIsNoFile(true);
      }
    });
  };

  return (
    <div className="background-container">
      {loading ? (
        <Spinner />
      ) : (
        <>

          <header className="header">
            <img
              src={back}
              style={{ height: 20, width: 20 }}
              alt="back button"
              onClick={backHandler}
            />
            <h1 className="header-title">Medical-Records</h1>
            <InfoIcon
              style={{ cursor: "pointer", marginLeft: "auto" }}
              onClick={() => setIsInfoModalOpen(true)} // Open modal on click
            />
          </header>
            <Dialog
              open={isInfoModalOpen}
              onClose={() => setIsInfoModalOpen(false)}
              aria-labelledby="info-dialog-title"
              PaperProps={{
                style: {
                  borderRadius: "12px", // Rounded corners
                  maxWidth: "500px", // Limit modal width
                  width: "90%", // Responsive width
                  maxHeight: "80vh", // Limit modal height
                  overflow: "hidden", // Hide overflow
                },
              }}
            >
              <DialogTitle
                id="info-dialog-title"
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  padding: "16px 24px",
                  borderBottom: "1px solid #e0e0e0", // Add a subtle border
                }}
              >
                Information
              </DialogTitle>
              <DialogContent
                style={{
                  padding: "16px 24px",
                  overflowY: "auto", // Enable vertical scrolling
                  scrollbarWidth: "none", // Hide scrollbar for Firefox
                  msOverflowStyle: "none", // Hide scrollbar for IE/Edge
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px", // Add spacing between steps
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "rgb(34, 189, 250)",
                        margin: "0 0 8px 0", // Add margin for spacing
                      }}
                    >
                      Step 1
                    </p>
                    <p style={{ fontSize: "16px", margin: 0 }}>
                      Click on the "Add folder" button to create a new folder. Provide the
                      doctor's name and visiting purpose in the popup to name the folder.
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "rgb(34, 189, 250)",
                        margin: "0 0 8px 0", // Add margin for spacing
                      }}
                    >
                      Step 2
                    </p>
                    <p style={{ fontSize: "16px", margin: 0 }}>
                      Click on a folder card to open the Medical Record View page.
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "rgb(34, 189, 250)",
                        margin: "0 0 8px 0", // Add margin for spacing
                      }}
                    >
                      Step 3
                    </p>
                    <p style={{ fontSize: "16px", margin: 0 }}>
                      In the Medical Record View screen, view or add records like
                      prescriptions and lab reports under that folder. Click on the plus sign
                      button to add new records.
                    </p>
                  </div>
                </div>
              </DialogContent>
              <DialogActions
                style={{
                  padding: "16px 24px",
                  borderTop: "1px solid #e0e0e0", // Add a subtle border
                }}
              >
                <Button
                  onClick={() => setIsInfoModalOpen(false)}
                  style={{
                    textTransform: "none", // Prevent uppercase text
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#1976d2", // Use a primary color
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

          <div style={{ width: "100%", position: "relative", }}>
            {/* Main Content */}
            <div style={{ width: "100%", height: "85vh", overflowY: "auto", paddingBottom: "10px", scrollbarWidth: "none", msOverflowStyle: "none", }}>
              {refreshUploadedDoc === true && cameraOpen === false ? (
                <>
                  {uploadedFolder.map((details) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className="medical-records-cards"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 15px",
                            margin: "5px 0",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            width: "90%", // Adjust to control item width
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexGrow: 1, // This will make the folder div take all remaining space
                            }}
                            onClick={() => {
                              navigate("/ViewMedicalRecors", {
                                state: details,
                              });
                            }}
                          >
                            <img
                              src={folder}
                              alt="Folder Icon"
                              style={{
                                height: "30px",
                                width: "30px",
                                marginRight: "10px",
                              }}
                            />
                            <div style={{ marginLeft: 5 }}>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  margin: "0",
                                }}
                              >
                                {details.doctors_name}
                              </p>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#555",
                                }}
                              >
                                {details.visiting_purpose}
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              textAlign: "center",
                              flexShrink: 0, // Prevent the delete div from shrinking
                            }}
                          >
                            <p
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                margin: "0",
                              }}
                              onClick={() => {
                                navigate("/ViewMedicalRecors", {
                                  state: details,
                                });
                              }}
                            >
                              {details.date}
                            </p>
                            <img
                              src={deleteicon}
                              alt="Delete Icon"
                              style={{
                                height: "25px",
                                width: "25px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent triggering navigation
                                handleDeleteClickOpen(details.id);
                              }}
                            />
                          </div>
                        </div>

                      </div>
                    );
                  })}
                </>
              ) : null}
            </div>

            {/* Add Folder Button */}
            <div
              style={{
                width: "100%",
                padding: "10px 20px",
              }}
            >
              {addRecordButtonHide === false && (
                <button
                  onClick={() => setIsModalOpen(true)} // Open modal on button click
                  style={{
                    width: "100%", // Full width
                    padding: "10px 0", // Padding for button height
                    backgroundColor: "#1976d2", // Example color
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  Add Folder
                </button>
              )}
            </div>

            {/* Modal for Adding Folder */}
            <Dialog
              open={isModalOpen} // Controlled by isModalOpen state
              onClose={() => setIsModalOpen(false)} // Close modal
              aria-labelledby="add-folder-modal-title"
              PaperProps={{
                style: {
                  borderRadius: "12px", // Rounded corners
                  maxWidth: "500px", // Limit modal width
                  width: "90%", // Responsive width
                  padding: "20px", // Add padding inside the modal
                },
              }}
            >
              <DialogTitle id="add-folder-modal-title" style={{ textAlign: "center" }}>
                Add Folder
              </DialogTitle>
              <DialogContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px", // Add spacing between elements
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                        textAlign: "left",
                        marginBottom: "8px",
                      }}
                    >
                      Doctor's Name
                    </p>
                    <input
                      className="input_style"
                      value={doctorsName}
                      maxLength={24}
                      onChange={(event) => handleChangeDoctorsName(event)}
                      type="text"
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                        textAlign: "left",
                        marginBottom: "8px",
                      }}
                    >
                      Visiting Purpose
                    </p>
                    <input
                      className="input_style"
                      value={visitingPurpose}
                      maxLength={30}
                      onChange={(event) => handleChangeVisitingPurpose(event)}
                      type="text"
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                </div>
              </DialogContent>
              <DialogActions
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px", // Add spacing between buttons
                  padding: "16px",
                }}
              >
                <button
                  onClick={() => setIsModalOpen(false)} // Close modal
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={(event) => {
                    uploadFolder(event); // Handle form submission
                    setIsModalOpen(false); // Close modal after submission
                  }}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  Add
                </button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={deleteOpen}
              onClose={handleDeleteClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Are you sure you want to delete this document?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description"></DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDeleteClose}>Cancel</Button>
                {isDeleteDoc === false ? (
                  <form
                    method="post"
                    onSubmit={(event) => deleteDocumentsHandler(event)}
                  >
                    <Button type="submit" autoFocus>
                      Delete
                    </Button>
                  </form>
                ) : (
                  <p
                    style={{
                      color: "red",
                      fontSize: 15,
                      fontWeight: "bold",
                      marginLeft: 10,
                      marginTop: -5,
                    }}
                  >
                    Deleting...
                  </p>
                )}
              </DialogActions>
            </Dialog>
          </div>
        </>
      )}
    </div>
  );
};
